import React from "react"

const createSpanFromMatches = (matches, text, restProps = {}) => {
  const content = text.split(`${matches[0]}[${matches[2]}]`)
  return [...new Set(content)].map((text) =>
    text === "" ? (
      <span
        key={Math.random()}
        {...restProps}
        style={{ color: `${matches[2]}`, display: "inherit" }}
      >
        {matches[1]}
      </span>
    ) : (
      text
    )
  )
}

export const addColour = (children = []) => {
  const mappedChildren = children.flatMap((child) => {
    if (typeof child === "string") {
      const matches = child.match(/\((.+)\)(?=\[(#\w+)\])/)
      if (matches) {
        return createSpanFromMatches(matches, child)
      }
    }
    if (typeof child === "object") {
      const content = child[1]
      const className = child.props?.className
      const matches =
        typeof content === "string" && content.match(/\((.+)\)(?=\[(#\w+)\])/)

      if (matches) {
        return createSpanFromMatches(matches, content, { className })
      }
    }
    return child
  })
  return mappedChildren
}
